export const projectDetailRoutes = [
  '/executive_summary',
  '/ghg_rating',
  '/sdg_rating',
  '/esr_rating',
  '/project_comparison',
  '/related_content',
  '/ratings-scales-explained',
];

export const RESEARCH_HUB_PATH = '/research-hub';

// Figma 224:34447: Apple SupplyBridge, Project ratings, Research hub. Nothing else.
export const APPLE_NAV_PATHS = ['/supply-bridge', '/credit-ratings', RESEARCH_HUB_PATH];
